"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMensItem = exports.yupMensItem = void 0;
const yup = __importStar(require("yup"));
const __1 = require("..");
const utils_1 = require("../utils");
exports.yupMensItem = yup.object({
    idEmpresa: yup.number().positive().integer().nullable().default(null).label('Empresa'),
    idGrupo: yup.number().integer().label('Grupo').nullable().default(null),
    descricao: yup.string().default('').max(50).required().label('Descrição'),
    valor: yup.number().required().default(0).label('Valor'),
    conta: yup
        .mixed()
        .oneOf(Object.values(__1.ETipoConta))
        .required()
        .default(__1.ETipoConta['0001 - Matrícula'])
        .label('Tipo de produto'),
    cobranca: yup.bool().required().default(true).label('Não emitir cobrança'),
    semMultaJuros: yup.bool().required().default(false).label('Sem multa e juros'),
    inativo: yup.bool().required().default(false).label('Produto inativo'),
    nfse: yup.bool().required().default(false).label('Emitir NFS-e'),
    descPagDia: yup.bool().required().default(false).label('Desconto para pagamento em dia'),
    valorDesconto: yup.number().default(0).label('Valor do desconto'),
    descontoPercentual: yup.bool().required().default(false).label('Percentual'),
    diasAntecipacaoDesc: yup.number().integer().required().default(0).label('Dias de antecipação para desconto'),
    diaUtilDesc: yup.bool().required().default(false).label('Dias úteis'),
    descontoBoleto: yup.number().integer().required().default(0).label('Percentual de desconto para boleto'),
    nParCartao: yup.number().integer().nullable().default(0).label('Número de parcelas no cartão'),
    juroCartao: yup.number().nullable().default(0).label('Percentual de Juros no cartão'),
    descricaoExtra: yup.string().nullable().default(null).max(120).notRequired().label('Descrição extra no item da NFSe'),
    codigoServicoMunicipio: yup
        .string()
        .nullable()
        .default(null)
        .max(30)
        .notRequired()
        .label('Código de serviço na NFSe'),
    observacoes: yup.string().nullable().default(null).max(256).notRequired().label('Observação NFSe'),
    naturezaOperacao: yup.string().nullable().default(null).max(3).notRequired().label('Natureza da operação NFSe'),
    dataCompFixa: (0, utils_1.sge2Date)().nullable().default(null).notRequired().label('Competência fixa NFSe'),
    aliquotaIss: yup.number().nullable().default(null).notRequired().label('ISS NFSe'),
    descricaoServicoMunicipio: yup
        .string()
        .nullable()
        .default(null)
        .max(256)
        .notRequired()
        .label('Descrição do serviço no municipio NFSe'),
    itemListaServicoLC116: yup.string().nullable().default(null).max(256).notRequired().label('Item Lista Serviço NFSe'),
    cnae: yup.string().nullable().default(null).max(256).notRequired().label('CNAE NFSe'),
    valorCofins: yup.number().nullable().default(null).notRequired().label('COFINS NFSe'),
    valorCsll: yup.number().nullable().default(null).notRequired().label('CSLL NFSe'),
    valorInss: yup.number().nullable().default(null).notRequired().label('INSS NFSe'),
    valorIr: yup.number().nullable().default(null).notRequired().label('IR NFSe'),
    valorPis: yup.number().nullable().default(null).notRequired().label('PIS NFSe'),
    deducoes: yup.number().nullable().default(null).notRequired().label('Deduções NFSe'),
});
exports.schemaMensItem = exports.yupMensItem.shape({});
